// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"a26f60f2","348":"f3e936cd","571":"0990ce44","924":"5721ca83"}[chunkId] + ".chunk.js";
};